import { render } from "./UserGuru.vue?vue&type=template&id=cc33d690"
import script from "./UserGuru.vue?vue&type=script&lang=js"
export * from "./UserGuru.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__